import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.reducer';
import * as fromUser from '../../store/user.actions';
import { Actions, ofType } from '@ngrx/effects';
import { UploadStatus } from '../../models/upload-status.model';
import { UserOrder } from '../../models/user-order.model';

@Injectable({
  providedIn: 'root'
})
export class UserOrdersResolverService implements Resolve<Observable<UserOrder[]>> {

  constructor(
    private store: Store<AppState>,
    private actions$: Actions
  ) {
  }

  resolve(): Observable<UserOrder[]> {
    return this.store.select('user').pipe(
      take(1),
      switchMap(userState => {
        if (userState.isAuthorized) {
          if (userState.ordersUploadStatus !== UploadStatus.LOADED) {
            if (userState.ordersUploadStatus === UploadStatus.NO) {
              this.store.dispatch(fromUser.userFetchingOrdersAction());
            }
            return this.actions$.pipe(
              ofType(fromUser.userStoreOrdersAction),
              take(1),
              map(value => value.payload)
            );
          } else {
            return of(userState.orders);
          }
        } else {
          return of([]);
        }
      })
    );
  }
}
